import { render } from "./TankReportVengurla.vue?vue&type=template&id=dec10ecc"
import script from "./TankReportVengurla.vue?vue&type=script&lang=js"
export * from "./TankReportVengurla.vue?vue&type=script&lang=js"

import "./TankReportVengurla.vue?vue&type=style&index=0&id=dec10ecc&scopped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__